import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Servicio encargado de interacturar con un estado de agendamiento.
 */
class StateSchedulingApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see StateScheduling
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'scheduling-state', 'StateScheduling');
    }
    /**
     * Metodo encargado de consultar por llave valor estado de agendamiento
     * @param stateLive Estado de vida del estado de agendamiento
     * @returns Retorna un array con los estados de agendamiento
     */
    GetByStateLive(stateLive) {
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByStateLive?stateLive=${stateLive}`));
    }
}
StateSchedulingApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StateSchedulingApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
StateSchedulingApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StateSchedulingApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: StateSchedulingApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Servicio encargado de interacturar con un motivo de estado de agendamiento.
 */
class ReasonStateSchedulingApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see StateScheduling
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'scheduling-state', 'ReasonStateScheduling');
    }
    /**
     * Metodo encargado de consultar por llave valor estado de agendamiento
     * @param idStateScheduling Id esatdo de agendamiento
     * @returns Retorna un array con los ids del grupo ciudad cliente campaña
     */
    GetByIdStateScheduling(args) {
        const data = {
            idStateScheduling: 0,
            name: '',
            description: '',
            ...args
        };
        const reasonStateScheduling = `${data.idStateScheduling}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByIdStateScheduling/${reasonStateScheduling}`));
    }
    /**
     * Metodo encargado de consultar los registros paginandolos
     * @param pagin Parametros de la paginación
     * @param args Argumentos extra para la consulta de información
     * @returns Objeto de tipo @see PageResult con la información
     * @example
     * // Get records paginated from server
     * this.service.pagination({ pageSize: 10, pageNumber: 1 }).suscribe(x => console.log(x))
     */
    GetByIdStateSchedulingPagination(pagin, args) {
        const data = {
            idStateScheduling: 0,
            name: '',
            description: '',
            ...args
        };
        const reasonStateScheduling = `/GetByIdStateSchedulingPagination/${data.idStateScheduling}`;
        const paginUrlReasonStateScheduling = `?PageSize=${pagin.pageSize}&PageNumber=${pagin.pageNumber}`;
        return this.getUri(uri => this.httpClient.get(`${uri}${reasonStateScheduling}${paginUrlReasonStateScheduling}`));
    }
}
ReasonStateSchedulingApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ReasonStateSchedulingApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ReasonStateSchedulingApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ReasonStateSchedulingApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ReasonStateSchedulingApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Servicio encargado de interacturar con un motivo de estado de agendamiento.
 */
class DetailReasonStateSchedulingApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see StateScheduling
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'scheduling-state', 'DetailReasonStateScheduling');
    }
    /**
     * Metodo encargado de consultar por llave valor  idReasonStateScheduling
     * @param idReasonStateScheduling Id motivo del estado de agendamiento
     * @returns Retorna un array con los ids del grupo ciudad cliente campaña
     */
    GetByIdReasonStateScheduling(args) {
        const data = {
            idReasonStateScheduling: 0,
            name: '',
            description: '',
            ...args
        };
        const reasonStateScheduling = `${data.idReasonStateScheduling}`;
        const GetBy = 'GetByIdReasonState';
        return this.getUri(uri => this.httpClient.get(`${uri}/${GetBy}/${reasonStateScheduling}`));
    }
    /**
     * Metodo encargado de consultar los registros paginandolos
     * @param pagin Parametros de la paginación
     * @param args Argumentos extra para la consulta de información
     * @returns Objeto de tipo @see PageResult con la información
     * @example
     * // Get records paginated from server
     * this.service.pagination({ pageSize: 10, pageNumber: 1 }).suscribe(x => console.log(x))
     */
    GetByIdReasonStateSchedulingPagination(pagin, args) {
        const data = {
            idReasonStateScheduling: 0,
            name: '',
            description: '',
            ...args
        };
        const detailReasonStateScheduling = `/GetByIdReasonStatePagination/${data.idReasonStateScheduling}`;
        const paginUrlDetailReasonStateScheduling = `?PageSize=${pagin.pageSize}&PageNumber=${pagin.pageNumber}`;
        return this.getUri(uri => this.httpClient.get(`${uri}${detailReasonStateScheduling}${paginUrlDetailReasonStateScheduling}`));
    }
}
DetailReasonStateSchedulingApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DetailReasonStateSchedulingApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
DetailReasonStateSchedulingApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DetailReasonStateSchedulingApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: DetailReasonStateSchedulingApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of scheduling-state
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DetailReasonStateSchedulingApiService, ReasonStateSchedulingApiService, StateSchedulingApiService };
